// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ANIMAL LEGEND CONTENT */
.woW9rsdW5BCiHS0EIMtb {
  display: grid;
  grid-template-columns: 1fr 0;
}
.FbrEWID05brjCLjxAJIc {
  display: grid;
  grid-template-columns: 0.125fr 1.5fr 1fr;
  place-content: center;
  padding: 1.25rem 3rem 1.25rem 1rem;
  background: var(--map-background-color-light);
  transition: filter var(--hover-transition-duration);
  box-shadow: inset 1rem 0px 2rem rgba(0, 0, 0, 0.09375);
}

.woW9rsdW5BCiHS0EIMtb.HecUZSnQczmFlbd5U9iK {
  grid-template-columns: 1fr;
}

.woW9rsdW5BCiHS0EIMtb:not(.woW9rsdW5BCiHS0EIMtb.HecUZSnQczmFlbd5U9iK) {
  cursor: pointer;
}

.woW9rsdW5BCiHS0EIMtb:hover:not(.woW9rsdW5BCiHS0EIMtb.HecUZSnQczmFlbd5U9iK),
.woW9rsdW5BCiHS0EIMtb:focus:not(.woW9rsdW5BCiHS0EIMtb.HecUZSnQczmFlbd5U9iK),
.woW9rsdW5BCiHS0EIMtb:hover:not(.woW9rsdW5BCiHS0EIMtb.HecUZSnQczmFlbd5U9iK) .xK6q3ZVISG3Ip_o9IUqa,
.woW9rsdW5BCiHS0EIMtb:focus:not(.woW9rsdW5BCiHS0EIMtb.HecUZSnQczmFlbd5U9iK) .xK6q3ZVISG3Ip_o9IUqa {
  filter: brightness(95%);
}

.woW9rsdW5BCiHS0EIMtb:hover:has(.HecUZSnQczmFlbd5U9iK),
.woW9rsdW5BCiHS0EIMtb:focus:has(.HecUZSnQczmFlbd5U9iK),
.woW9rsdW5BCiHS0EIMtb:hover:not(:has(.HecUZSnQczmFlbd5U9iK)) .xK6q3ZVISG3Ip_o9IUqa,
.woW9rsdW5BCiHS0EIMtb:focus:not(:has(.HecUZSnQczmFlbd5U9iK)) .xK6q3ZVISG3Ip_o9IUqa {
  filter: none;
}

.woW9rsdW5BCiHS0EIMtb:hover:not(:has(.HecUZSnQczmFlbd5U9iK)) .WqmzXgjwGVrTM7NyKY06,
.woW9rsdW5BCiHS0EIMtb:focus:not(:has(.HecUZSnQczmFlbd5U9iK)) .WqmzXgjwGVrTM7NyKY06 {
  opacity: 0.5;
}

.KybXIVi2NIq7ipJaPrcg {
  display: flex;
  justify-content: center;
  align-items: center;
}

.GhYXzwecIOQkFU1zGmjN {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1.25rem;
}

.GhYXzwecIOQkFU1zGmjN div {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: green;
}

.Kd0rtNsscL5moFxS3Jp_ {
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: larger;
  overflow-wrap: normal;
}

.Lmq8JOYlOhlD_Q7CZ5lW {
  min-width: 0;
  display: block;
}

.inugWLLSlbtsF0gLsTa8:not(.HecUZSnQczmFlbd5U9iK .inugWLLSlbtsF0gLsTa8) {
  --font-size: calc(var(--map-h2-font-size) * 0.75);
  overflow: hidden;
  text-overflow: ellipsis;
}

.BAo4ODB1l6gwgCMsv3Bq {
  box-shadow: inset 1rem 0px 2rem rgba(0, 0, 0, 0.125);
}

#gw-map h3.map-heading.BCf9cYSkK_6CbMYip7Hh {
  font-size: var(--map-body-font-size);
}

#gw-map .PBztxsYNacNXb8da0m4D h2.map-heading.inugWLLSlbtsF0gLsTa8 {
  font-weight: 700;
}

#gw-map .PBztxsYNacNXb8da0m4D h3.map-heading.BCf9cYSkK_6CbMYip7Hh {
  font-weight: 500;
}

.HecUZSnQczmFlbd5U9iK.woW9rsdW5BCiHS0EIMtb {
  box-shadow: none;
}

.HecUZSnQczmFlbd5U9iK .FbrEWID05brjCLjxAJIc {
  background: var(--ocean-gradient);
  --h2-heading-color: #fff;
  --h3-heading-color: #fff;
  --body-text-color: #ccc;
  --default-icon-color: #ccc;
}

.HecUZSnQczmFlbd5U9iK .OX_GI_H9nRsI8Mc0tLny {
  --default-icon-color: #ccc;
  --iconButton-hover-filter-custom: brightness(1.5);
}

.HecUZSnQczmFlbd5U9iK .inugWLLSlbtsF0gLsTa8 {
  text-wrap: wrap;
  word-break: break-word;
}

.HecUZSnQczmFlbd5U9iK .GhYXzwecIOQkFU1zGmjN,
.HecUZSnQczmFlbd5U9iK .Lmq8JOYlOhlD_Q7CZ5lW {
  cursor: default;
}

.FEfjDLmO1N4HC88slzCS {
  display: flex;
  justify-content: flex-start;
}

.OsHuM6Dq_vPe2WJJBEhj > div {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.25rem;
}

.yuJ2_Pp4_LD5XWUlV2Lb {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
}

.BsJhp4HSqtzImsV3E7Ng {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.25rem;
}

.OX_GI_H9nRsI8Mc0tLny {
    display: flex;
    justify-content: center;
    align-items: center;
}

.BsJhp4HSqtzImsV3E7Ng button {
    flex: 0 1 56%;
}

.BsJhp4HSqtzImsV3E7Ng img,
.BsJhp4HSqtzImsV3E7Ng svg {
  margin: 0;
  box-sizing: content-box;
}

.xK6q3ZVISG3Ip_o9IUqa {
  all: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  right: 24px;
  width: 24px;
  height: 100%;
}

.xK6q3ZVISG3Ip_o9IUqa svg {
  flex: 1 1 100%;
}

.xK6q3ZVISG3Ip_o9IUqa :where(path) {
  stroke: #060a23 !important;
}

.HecUZSnQczmFlbd5U9iK .xK6q3ZVISG3Ip_o9IUqa {
  display: none;
}
/*
.storyButtonIcon {
  transition: opacity var(--hover-transition-duration);
}*/

@media screen and (max-width: 420px) {
  .FbrEWID05brjCLjxAJIc {
    grid-template-rows: 1fr 0.5fr;
    grid-template-columns: 0.25fr 1fr 1fr;
    grid-row-gap: 0.5rem;
    grid-template-areas:
      "animalStatus animalName animalName "
      ". trackButtons trackButtons ";
  }
  .GhYXzwecIOQkFU1zGmjN {
    grid-area: animalStatus;
  }
  .FEfjDLmO1N4HC88slzCS {
    grid-area: animalName;
  }
  .BsJhp4HSqtzImsV3E7Ng {
    grid-template-rows: 1fr;
    grid-template-columns: repeat(2, 0.33fr);
    grid-gap: 0.25rem;
    grid-area: trackButtons;
  }
  .OX_GI_H9nRsI8Mc0tLny {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./../core/components/legend/Animal.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,qBAAqB;EACrB,kCAAkC;EAClC,6CAA6C;EAC7C,mDAAmD;EACnD,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;AACA;;;EAGE;;AAEF;EACE;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,oBAAoB;IACpB;;oCAEgC;EAClC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,iBAAiB;IACjB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ANIMAL LEGEND CONTENT */\r\n.animalLegendContainer {\r\n  display: grid;\r\n  grid-template-columns: 1fr 0;\r\n}\r\n.animalLegendContentContainer {\r\n  display: grid;\r\n  grid-template-columns: 0.125fr 1.5fr 1fr;\r\n  place-content: center;\r\n  padding: 1.25rem 3rem 1.25rem 1rem;\r\n  background: var(--map-background-color-light);\r\n  transition: filter var(--hover-transition-duration);\r\n  box-shadow: inset 1rem 0px 2rem rgba(0, 0, 0, 0.09375);\r\n}\r\n\r\n.animalLegendContainer.animalStoryView {\r\n  grid-template-columns: 1fr;\r\n}\r\n\r\n.animalLegendContainer:not(.animalLegendContainer.animalStoryView) {\r\n  cursor: pointer;\r\n}\r\n\r\n.animalLegendContainer:hover:not(.animalLegendContainer.animalStoryView),\r\n.animalLegendContainer:focus:not(.animalLegendContainer.animalStoryView),\r\n.animalLegendContainer:hover:not(.animalLegendContainer.animalStoryView) .storyButton,\r\n.animalLegendContainer:focus:not(.animalLegendContainer.animalStoryView) .storyButton {\r\n  filter: brightness(95%);\r\n}\r\n\r\n.animalLegendContainer:hover:has(.animalStoryView),\r\n.animalLegendContainer:focus:has(.animalStoryView),\r\n.animalLegendContainer:hover:not(:has(.animalStoryView)) .storyButton,\r\n.animalLegendContainer:focus:not(:has(.animalStoryView)) .storyButton {\r\n  filter: none;\r\n}\r\n\r\n.animalLegendContainer:hover:not(:has(.animalStoryView)) .storyButtonIcon,\r\n.animalLegendContainer:focus:not(:has(.animalStoryView)) .storyButtonIcon {\r\n  opacity: 0.5;\r\n}\r\n\r\n.animalImg {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.animalStatus {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding-right: 1.25rem;\r\n}\r\n\r\n.animalStatus div {\r\n  height: 10px;\r\n  width: 10px;\r\n  border-radius: 50%;\r\n  background-color: green;\r\n}\r\n\r\n.animalName {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  font-size: larger;\r\n  overflow-wrap: normal;\r\n}\r\n\r\n.animalNameStyle {\r\n  min-width: 0;\r\n  display: block;\r\n}\r\n\r\n.animalNameText:not(.animalStoryView .animalNameText) {\r\n  --font-size: calc(var(--map-h2-font-size) * 0.75);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.animalStory {\r\n  box-shadow: inset 1rem 0px 2rem rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n:global(#gw-map) h3:global(.map-heading).animalSubtitleText {\r\n  font-size: var(--map-body-font-size);\r\n}\r\n\r\n:global(#gw-map) .tracksActive h2:global(.map-heading).animalNameText {\r\n  font-weight: 700;\r\n}\r\n\r\n:global(#gw-map) .tracksActive h3:global(.map-heading).animalSubtitleText {\r\n  font-weight: 500;\r\n}\r\n\r\n.animalStoryView.animalLegendContainer {\r\n  box-shadow: none;\r\n}\r\n\r\n.animalStoryView .animalLegendContentContainer {\r\n  background: var(--ocean-gradient);\r\n  --h2-heading-color: #fff;\r\n  --h3-heading-color: #fff;\r\n  --body-text-color: #ccc;\r\n  --default-icon-color: #ccc;\r\n}\r\n\r\n.animalStoryView .trackButtonContainer {\r\n  --default-icon-color: #ccc;\r\n  --iconButton-hover-filter-custom: brightness(1.5);\r\n}\r\n\r\n.animalStoryView .animalNameText {\r\n  text-wrap: wrap;\r\n  word-break: break-word;\r\n}\r\n\r\n.animalStoryView .animalStatus,\r\n.animalStoryView .animalNameStyle {\r\n  cursor: default;\r\n}\r\n\r\n.animalNameStatus {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.lastSeen > div {\r\n  display: flex;\r\n  flex-flow: column nowrap;\r\n  gap: 0.25rem;\r\n}\r\n\r\n.fitContent {\r\n  width: -webkit-fit-content;\r\n  width: -moz-fit-content;\r\n  width: fit-content;\r\n}\r\n\r\n.trackButtons {\r\n  display: grid;\r\n  grid-template-rows: 1fr;\r\n  grid-template-columns: 1fr 1fr;\r\n  grid-gap: 0.25rem;\r\n}\r\n\r\n.trackButtonContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.trackButtons button {\r\n    flex: 0 1 56%;\r\n}\r\n\r\n.trackButtons img,\r\n.trackButtons svg {\r\n  margin: 0;\r\n  box-sizing: content-box;\r\n}\r\n\r\n.storyButton {\r\n  all: unset;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n  right: 24px;\r\n  width: 24px;\r\n  height: 100%;\r\n}\r\n\r\n.storyButton svg {\r\n  flex: 1 1 100%;\r\n}\r\n\r\n.storyButton :where(path) {\r\n  stroke: #060a23 !important;\r\n}\r\n\r\n.animalStoryView .storyButton {\r\n  display: none;\r\n}\r\n/*\r\n.storyButtonIcon {\r\n  transition: opacity var(--hover-transition-duration);\r\n}*/\r\n\r\n@media screen and (max-width: 420px) {\r\n  .animalLegendContentContainer {\r\n    grid-template-rows: 1fr 0.5fr;\r\n    grid-template-columns: 0.25fr 1fr 1fr;\r\n    grid-row-gap: 0.5rem;\r\n    grid-template-areas:\r\n      \"animalStatus animalName animalName \"\r\n      \". trackButtons trackButtons \";\r\n  }\r\n  .animalStatus {\r\n    grid-area: animalStatus;\r\n  }\r\n  .animalNameStatus {\r\n    grid-area: animalName;\r\n  }\r\n  .trackButtons {\r\n    grid-template-rows: 1fr;\r\n    grid-template-columns: repeat(2, 0.33fr);\r\n    grid-gap: 0.25rem;\r\n    grid-area: trackButtons;\r\n  }\r\n  .trackButtonContainer {\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"animalLegendContainer": `woW9rsdW5BCiHS0EIMtb`,
	"animalLegendContentContainer": `FbrEWID05brjCLjxAJIc`,
	"animalStoryView": `HecUZSnQczmFlbd5U9iK`,
	"storyButton": `xK6q3ZVISG3Ip_o9IUqa`,
	"storyButtonIcon": `WqmzXgjwGVrTM7NyKY06`,
	"animalImg": `KybXIVi2NIq7ipJaPrcg`,
	"animalStatus": `GhYXzwecIOQkFU1zGmjN`,
	"animalName": `Kd0rtNsscL5moFxS3Jp_`,
	"animalNameStyle": `Lmq8JOYlOhlD_Q7CZ5lW`,
	"animalNameText": `inugWLLSlbtsF0gLsTa8`,
	"animalStory": `BAo4ODB1l6gwgCMsv3Bq`,
	"animalSubtitleText": `BCf9cYSkK_6CbMYip7Hh`,
	"tracksActive": `PBztxsYNacNXb8da0m4D`,
	"trackButtonContainer": `OX_GI_H9nRsI8Mc0tLny`,
	"animalNameStatus": `FEfjDLmO1N4HC88slzCS`,
	"lastSeen": `OsHuM6Dq_vPe2WJJBEhj`,
	"fitContent": `yuJ2_Pp4_LD5XWUlV2Lb`,
	"trackButtons": `BsJhp4HSqtzImsV3E7Ng`
};
module.exports = ___CSS_LOADER_EXPORT___;
